import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import rest from '../axios';

const CategoriesAdditionalComponent = () => {
  const [providers, setProviders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [allSubcategories, setAllSubcategories] = useState([]);
  const [search, setSearch] = useState('');
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [showDeleteCategoryModal, setShowDeleteCategoryModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [newCategory, setNewCategory] = useState({ provider_id: '', category_id: '', subcategory_id: '' });

  useEffect(() => {
    rest.get('admin/providers')
      .then(response => {
        setProviders(response.data?.data)
      })
      .catch(error => console.error('Erro ao buscar prestadores:', error));

    rest.get('admin/additional-categories')
      .then(response => {
        setCategories(response.data?.data)
      })
      .catch(error => console.error('Erro ao buscar categorias adicionais:', error));

    rest.get('admin/categories')
      .then(response => {
        const uniqueCategories = Array.from(new Set(response.data?.data?.map(a => a.name)))
          .map(name => response.data?.data?.find(a => a.name === name));
        setAllCategories(uniqueCategories);
      })
      .catch(error => console.error('Erro ao buscar todas as categorias:', error));
  }, []);

  const filterTable = () => {
    if (search === '') {
      rest.get('admin/providers')
        .then(response => {
          setProviders(response.data?.data);
        })
        .catch(error => console.error('Erro ao buscar prestadores:', error));
    } else {
      const filteredProviders = providers.filter(provider =>
        provider.name.toLowerCase().includes(search.toLowerCase())
      );
      setProviders(filteredProviders);
    }
  };

  const handleCategoryChange = (categoryId, providerId) => {
    setNewCategory({ ...newCategory, category_id: categoryId, provider_id: providerId });
    rest.get(`/admin/subcategories/category/${categoryId}`)
      .then(response => {
        setAllSubcategories(response.data?.data);
      })
      .catch(error => console.error('Erro ao buscar subcategorias:', error));
  };

  const handleAddCategory = () => {
    if (!newCategory.category_id || !newCategory.subcategory_id || !newCategory.provider_id) {
      alert('Categoria, Subcategoria e Provider são obrigatórios!');
      return;
    }

    rest.post('admin/additional-categories', {
      provider_id: Number(newCategory.provider_id),
      category_id: Number(newCategory.category_id),
      subcategory_id: Number(newCategory.subcategory_id)
    })
      .then(() => {
        setShowAddCategoryModal(false);
        setNewCategory({ provider_id: '', category_id: '', subcategory_id: '' });
        rest.get('admin/additional-categories').then(response => setCategories(response.data?.data));
      })
      .catch(error => {
        console.error('Erro ao adicionar categoria:', error);
      });
  };

  const handleDeleteCategory = () => {
    rest.delete(`admin/additional-categories/${selectedCategory.id}`)
      .then(() => {
        setShowDeleteCategoryModal(false);
        rest.get('admin/additional-categories').then(response => setCategories(response.data?.data));
      })
      .catch(error => console.error('Erro ao excluir categoria:', error));
  };

  return (
    <div className="containers">
      <h1>Gerenciar Categorias Adicionais</h1>

      {/* Barra de Pesquisa */}
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Pesquisar prestador pelo nome..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyUp={filterTable}
        />
      </div>

      {/* Tabela de Prestadores */}
      <div className="table-responsive">
        <table className="table mt-4">
          <thead>
            <tr>
              <th>Prestador</th>
              <th>Categorias Adicionais</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {providers.length > 0 ? (
              providers.map(provider => {

                const providersConfig = categories.filter(category => category.provider_id === provider.id);
                console.log('providersConfig', providersConfig, provider?.name);
                return (
                  <tr key={provider.id}>
                    <td>{provider.name}</td>
                    <td>
                      {providersConfig.length > 0 ? (
                        providersConfig.map((config, index) => (
                          <div key={index} className="d-flex justify-content-start align-items-center mb-2">
                            <span className="me-3">
                              {config.category.name} - {config.subcategory.name || 'Sem Subcategoria'}
                            </span>
                            <div className="d-flex gap-2">
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => {
                                  setSelectedCategory(config);
                                  setShowDeleteCategoryModal(true);
                                }}
                              >
                                Excluir
                              </button>
                            </div>
                          </div>
                        ))
                      ) : (
                        <span>Sem Categorias Adicionais</span>
                      )}
                    </td>
                    <td>
                      <button
                        className="btn btn-secondary mt-6"
                        onClick={() => {
                          setSelectedCategory(provider);
                          setShowAddCategoryModal(true);
                        }}
                      >
                        Adicionar Categoria Adicional
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="3">Nenhum prestador encontrado.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal Adicionar Categoria Adicional */}
      <Modal show={showAddCategoryModal} onHide={() => setShowAddCategoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Adicionar Categoria Adicional</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Categoria</Form.Label>
              <select
                className="form-control"
                value={newCategory.category_id}
                onChange={(e) => {
                  handleCategoryChange(e.target.value, selectedCategory.id);
                }}
              >
                <option value="">Selecione uma Categoria</option>
                {allCategories.map(category => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </select>
            </Form.Group>
            <Form.Group>
              <Form.Label>Subcategoria</Form.Label>
              <select
                className="form-control"
                value={newCategory.subcategory_id}
                onChange={(e) => setNewCategory({ ...newCategory, subcategory_id: e.target.value })}
              >
                <option value="">Selecione uma Subcategoria</option>
                {allSubcategories.map(subcategory => (
                  <option key={subcategory.id} value={subcategory.id}>
                    {subcategory.name}
                  </option>
                ))}
              </select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddCategoryModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleAddCategory}>
            Adicionar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Excluir Categoria Adicional */}
      <Modal show={showDeleteCategoryModal} onHide={() => setShowDeleteCategoryModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Excluir Categoria Adicional</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Tem certeza de que deseja excluir a categoria <strong>{selectedCategory?.categories?.name}</strong>?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteCategoryModal(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleDeleteCategory}>
            Excluir
          </Button>
        </Modal.Footer>
      </Modal>  {/* Fechando a tag Modal corretamente */}

    </div>
  );
};

export default CategoriesAdditionalComponent;
